import { render, staticRenderFns } from "./modalStatus.vue?vue&type=template&id=52ca47d6"
import script from "./modalStatus.vue?vue&type=script&lang=js"
export * from "./modalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports